import { Component, Input } from '@angular/core';
import { WarningOrError } from '../../../create-request/models/shared/WarningOrError';

@Component({
  standalone: false,
  selector: 'mm-error-summary',
  templateUrl: './error-summary.component.html',
  styleUrls: ['./error-summary.component.scss']
})
export class ErrorSummaryComponent {
  @Input() errors: WarningOrError[] = [];
  @Input() summaryText: string;

  constructor() { }

  scrollToMessageField(id: string): void {
    const elem = document.getElementById(id);
    elem?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
  }
}
